<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Agregar producto complementario</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- Upload -->
        <div class="upload-img mb-5" v-if="!product.image">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Subir imagen</vs-button>
        </div>
        <!-- Product Image -->
        <template v-if="product.image">
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="product.image" alt="img" class="responsive">
          </div>
          <div class="modify-img mb-4 text-center">
            <vs-button type="flat" color="#999" @click="product.image=null">Eliminar imagen</vs-button>
          </div>
        </template>

        <!-- Name -->
        <vs-input data-vv-as="nombre" @blur="product.name = trimString(product.name)" label="Nombre"
                  v-model="product.name"
                  class="w-full" name="name"
                  v-validate="'required|min:3'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <!-- Price -->
        <vs-input data-vv-as="precio" label="Precio"
                  v-model.number="product.normalPrice"
                  type="number"
                  class="mt-5 w-full" name="normalPrice"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('normalPrice')">{{ errors.first('normalPrice') }}</span>

        <!-- Order -->
        <vs-input data-vv-as="orden" label="Orden"
                  v-model.number="product.order"
                  type="number"
                  class="mt-5 w-full" name="order"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('order')">{{ errors.first('order') }}</span>

        <!-- Categories -->
        <div class="mt-5">
          <label class="vs-input--label">Categorías</label>
          <v-select multiple :options="categoriesList" label="name" v-model="product.categories"
                    :reduce="c => ({id: c.id, name: c.name})"
                    name="categories" placeholder="Seleccionar categorías"/>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trimString from '../../mixins/trimString'
import vSelect from 'vue-select'

import { auth, db, FieldValue } from '@/firebase/firebaseConfig'
import { uploadToCloudflare } from '@/services/cloudflareImages'

export default {
  name: 'NewCrossSellProduct',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  mixins: [trimString],
  data () {
    return {
      product: {},
      categoriesList: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false,
      newImage: null
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) {
        this.product = {}
        this.newImage = null
        this.$validator.reset()
      }
    },
    product: {
      handler () {
        if (this.product.image === null) {
          this.newImage = null
        }
      },
      deep: true
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    async submitData () {
      try {
        let result = await this.$validator.validateAll()
        if (result) {
          this.progress = true
          if (this.newImage != null) {
            this.product.image = await uploadToCloudflare(this.newImage)
          }
          const categories = this.product.categories || []
          const obj = {
            name: this.product.name,
            image: this.product.image || '',
            normalPrice: this.product.normalPrice,
            order: this.product.order,
            categories: categories,
            categoryIds: categories.map(c => c.id),
            state: true,
            uid: auth.currentUser.uid,
            createdAt: FieldValue.serverTimestamp()
          }
          const doc = await db.collection('crossSellProducts').add({
            ...obj
          })
          obj.id = doc.id
          this.$emit('add', obj)
          this.$emit('closeSidebar')
          this.$vs.notify({
            color: 'success',
            title: 'Producto complementario',
            text: 'Producto creado correctamente.'
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.progress = false
      }
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.$set(this.product, 'image', e.target.result)
          this.newImage = input.target.files[0]
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
  async created () {
    try {
      const querySnapshot = await db.collection('categories').orderBy('order', 'asc').where('state', '==', true).get()
      querySnapshot.forEach((doc) => {
        this.categoriesList.push({
          id: doc.id,
          name: doc.data().name
        })
      })
    } catch (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
